<template>
	<div id="app">
		<!-- <transition name="van-fade"> -->
		<!-- <keep-alive :include='["home_index"]'> -->
		<router-view></router-view>
		<!-- </keep-alive> -->
		<!-- </transition> -->
		<van-popup v-model="data.showLogin" position="bottom" closeable @close='close' class="popup-login">
			<div class="pt-15 pl-10 pr-10 pb-20">
				<div class="tcenter pt-10 pb-20">
					身份验证
				</div>
				<template v-if="$config.wx.isWX && type == 0">
					<button class="sd-btn btn-primary block" large round style="position: relative;">
						<span>使用微信授权身份信息</span>
						<wx-open-launch-weapp appid="wx0cee88b27053c290" :path="`pages/oauth/index`" @click="handle_weapp">
							<script type="text/wxtag-template"><button style='display:inline-block;position:absolute;width:100%;height:100%;'>使用微信授权身份信息</button></script>
						</wx-open-launch-weapp>
					</button>
				</template>
				<template v-else>
					<van-field class="fz18" size='large' type='tel' v-model='phone' required label='手机号' placeholder='请输入手机号'></van-field>
					<van-field class="fz17" size='large' v-model="vcode" required center clearable label="短信验证码" placeholder="请输入短信验证码">
						<template #button>
							<button class="sd-btn btn-primary" @click='sendCode' v-if='time <= 0'>发送验证码</button>
							<a v-else>{{ time }}s</a>
						</template>
					</van-field>
					<button class="mt-10 mb-10 sd-btn btn-primary w100 block" large @click='submit'>提交验证</button>
				</template>
				<div class="d-flex mt-20 mb-20 f-main underline" center middle v-if="$config.wx.isWX">
					<span v-if="type == 0" @click="type = 1">手机验证码登录</span>
					<span v-else @click="type = 0">微信授权登陆</span>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<script>
	import { mapModules, mapRules } from "vuet";
	export default {
		mixins: [
			mapModules({
				data: "root",
			}),
		],
		data() {
			return {
				phone: "",
				vcode: "",
				time: 0,
				type: this.$config.wx.isWX ? 0 : 1,
			};
		},
		methods: {
			handle_weapp() {
				var i = 0;
				document.addEventListener("visibilitychange", (e) => {
					if (i >= 1) {
						this.$config.userinfo.login_status = 0;
						this.$login();
					}
					i++;
				});
			},
			close() {
				this.data.login_callback(false);
			},
			submit() {
				if (!this.phone || !this.vcode) {
					this.$alert("手机号码和验证码不能为空！");
					return;
				}
				this.$api.user.login(this.phone, this.vcode).then((res) => {
					if (res.access_token) {
						this.$vuet.getModule("root").fetchlist = [];
						this.$config.setToken(res.access_token);
						this.$config.userinfo.token = res.access_token;
						this.data.showLogin = false;
						this.data.login_callback(true);
						// if (this.$route.query["from"]) {
						//   this.$router.replace(this.$route.query["from"])
						// } else {
						//   this.$router.replace("/");
						// }
					} else {
						this.$alert(res.error);
					}
				});
			},
			start() {
				setTimeout(() => {
					this.time--;
					if (this.time > 0) this.start();
				}, 1000);
			},
			sendCode() {
				if (!this.phone) {
					this.$alert("请输入手机号码");
					return;
				}

				this.$api.user
					.sendCode({
						phone: this.phone,
					})
					.then((res) => {
						if (res.R) {
							this.vcode = res.data;
							this.time = 60;
							this.start();
						} else {
							this.$alert(res.msg);
							if (res.code == "SmsCodeTime") {
								this.time = parseInt(res.data);
								this.start();
							}
						}
					});
			},
		},
		mounted() {
			this.$api.wx.config(
				"MAZ智能物联场景",
				"随身办智能物联MAZ智联场景15分钟生活圈",
				"https://15.sunagy.com",
				""
			);
		},
	};
</script>
<style lang="less">
#app {
	font-family: "web-font", "Helvetica Neue", Helvetica, "PingFang SC",
		"Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	// -webkit-font-smoothing: antialiased;
	// -moz-osx-font-smoothing: grayscale;
	color: #333333;
	width: 100%;
	height: 100%;
	background-color: @bg;
}

.popup-login {
	.van-cell {
		padding-right: 0;
	}

	wx-open-launch-weapp {
		display: inline-block;
		opacity: 0;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0px;
		left: 0px;
		z-index: 1;
	}
}
</style>
